module.exports = __webpack_public_path__ + "static/media/loading.cc387905.gif";